import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {LeadIcon} from 'shells/icon/svg/lead-icon';
import {TwoLine} from 'shells/two-line/two-line';
import {TwoLineButtonCard} from 'shells/two-line/two-line-button-card';

import type {GetForm_form_createRules_lead as CreateRulesLeadFragment} from 'nutshell-graphql-types';

import {CreateRulesActionText} from './create-rules-action-text';
import {isCreateRuleEmpty} from './helpers';

type Props = {
    createRules: CreateRulesLeadFragment | null | undefined;
    onClick: () => void;
};

export function CreateRulesCardLead(props: Props) {
    return (
        // @ts-expect-error
        <TwoLineButtonCard borderColor={colors.lead} onClick={props.onClick}>
            <TwoLine
                icon={LeadIcon}
                iconSize={24}
                iconColor={colors.lead}
                topRow='Create a lead'
                bottomRow={getSubtitle(props.createRules)}
                isLargeWithSmallBottomRow={true}
                shouldCenterSingleLine={true}
            />
            <CreateRulesActionText createRules={props.createRules} />
        </TwoLineButtonCard>
    );
}

function getSubtitle(createRules?: CreateRulesLeadFragment | null): string | null | undefined {
    if (!createRules || isCreateRuleEmpty(createRules)) {
        return null;
    }

    let stagesetInfo = '';
    const numStagesetFieldRules = createRules.stagesetFieldRules.length;
    if (numStagesetFieldRules) {
        const term = numStagesetFieldRules === 1 ? 'case' : 'cases';
        stagesetInfo = `• ${numStagesetFieldRules} special ${term}`;
    }

    const parts = [];
    if (createRules.stageset) {
        parts.push(`Pipeline: ${createRules.stageset.name} ${stagesetInfo}`);
    } else if (createRules.stageset === null) {
        parts.push(`Pipeline: Auto distribute ${stagesetInfo}`);
    }

    if (createRules.tags.length) {
        const tagNames = createRules.tags
            .map((tag) => {
                return tag.name;
            })
            .join(', ');

        parts.push(`Tags: ${tagNames}`);
    }

    return parts.join(', ');
}
